import React from "react";
import I18n from "redux-i18n";

import { translations } from "lib/translations";

translations.options.suppress_warnings = true;

export default function I18nProvider({ children }) {
    return <I18n translations={translations}>{children}</I18n>;
}
